import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import * as classSelectors from 'common.components/classes/selectors';
import * as selectors from 'common.components/lesson-view.assignment/selectors';
import * as lessonEditorSelectors from 'common.components/lesson/selectors';
import { isLessonInProgress } from 'common.components/lesson/utils';
import * as userSelectors from 'common.components/user/selectors';
import { getIsTeacherFromMes } from 'utils/external-lms/external-lms';
import { getSearchFromProps } from 'utils/selectors/selectors';

export const getShouldHideLessonMode = createSelector([lessonEditorSelectors.getLesson], (lesson): boolean =>
    Boolean(lesson?.meta?.is_mode_readonly)
);

export const getAllTeamCheckboxDisabled = createSelector(
    [lessonEditorSelectors.getLessonStatus, getSearchFromProps],
    (lessonStatus, search) => {
        const isTeacherFromMes = getIsTeacherFromMes(search);
        return isLessonInProgress(lessonStatus || LESSON_STATUS.NOT_ASSIGNED) || isTeacherFromMes;
    }
);

export const getShouldShowStudentsLoader = createSelector(
    [selectors.getShouldShowStudentsLoader, userSelectors.getHasNoActiveTeams, classSelectors.getIsTeamLoaded],
    (shouldShow, hasNoTeams, isTeamLoaded) => shouldShow || (!hasNoTeams && !isTeamLoaded)
);
